/**
 * Список выпусков, на которых построен расчёт.
 *
 * Требование ТЗ, а не удобство: без него ответ невозможно проверить. Поэтому
 * он есть на каждой карточке, где он есть в ответе, и заменять его одним
 * числом нельзя. Свёрнут, потому что выпусков бывает две сотни.
 */

import { useState } from "react";

import type { QueryResultDTO } from "../api/types";
import { formatDate } from "./format";

const CHUNK = 25;

export function VideoBasis({ result }: { result: QueryResultDTO }) {
  const [limit, setLimit] = useState(CHUNK);
  if (result.videos.length === 0) return null;

  const shown = result.videos.slice(0, limit);
  const hidden = result.videos.length - shown.length;
  // Список выпусков сервер обрезает двумя сотнями, а основание бывает шире.
  const truncated = result.videos.length < result.video_count;

  return (
    <details className="basis">
      <summary className="basis__summary">
        Основание расчёта: {result.video_count} выпусков
        {truncated && `, в списке первые ${result.videos.length}`}
      </summary>
      <ul className="basis__list">
        {shown.map((video) => (
          <li key={video.youtube_id}>
            <span className="basis__date">{formatDate(video.published_at)}</span>
            <a href={video.url} target="_blank" rel="noreferrer">
              {video.title}
            </a>
          </li>
        ))}
      </ul>
      {hidden > 0 && (
        <button type="button" className="button button--ghost" onClick={() => setLimit(limit + CHUNK)}>
          Показать ещё {Math.min(hidden, CHUNK)}
        </button>
      )}
    </details>
  );
}
